document.addEventListener('DOMContentLoaded', function() {
  const ratingLabels = document.querySelectorAll('.rating-stars__label');
  const reviewCard = document.querySelector('.faq-answer.lastfaq');

  if (ratingLabels.length > 0 && reviewCard) {
    ratingLabels.forEach(function(label) {
      label.addEventListener('click', function(event) {
        event.preventDefault(); 
        reviewCard.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
    // Find your button
    const scrollToTopButtons = document.querySelectorAll('.features-cta-button');

    if (scrollToTopButtons) {
        scrollToTopButtons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

});


function getScrollbarInfo() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add inner div
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    // Calculate scrollbar width
    var scrollbarWidth = widthNoScroll - widthWithScroll;

    // Calculate the difference between window's inner width and body's client width
    var scrollbarPosition = scrollbarWidth === (window.innerWidth - document.body.clientWidth) ? 'right' : 'left';

    return {
        position: scrollbarPosition,
        width: scrollbarWidth
    };
}


function showDescription() {
  if($('.Collapsible__Button').attr("aria-expanded") == "false") {
    $(".Collapsible__Button").attr("aria-expanded","true");
    $('.shg-c').toggleClass('animated');
  } else {
    $(".Collapsible__Button").attr("aria-expanded","false");
    $('.shg-c').toggleClass('animated');
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
  
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
  	if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }


  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener); 
    
class IshiModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'ISHIMODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.classList.add("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.add("active") : '';
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.classList.remove("active");
    document.querySelector('.newsletter-popup-overlay')? document.querySelector('.newsletter-popup-overlay').classList.remove("active") : '';
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if(this.getAttribute("id") == "PopupModal-newsletter"){
      if($('.dono-show-check').prop("checked") == true) {
        setTheCookie("customer_posted", "true", 14);
      }
  	}
  }
}
customElements.define('ishimodal-dialog', IshiModalDialog);

class IshiModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.ishi-popup-modal__button');
    if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
    });
  }
}
customElements.define('ishimodal-opener', IshiModalOpener);

class QuickviewDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'QUICKVIEW-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    var test = this.openedBy;
    const popup = this.querySelector('.template-popup');
    disableScroll();
    this.setAttribute('open', '');
    this.classList.add("active");
    this.querySelector(".qv-wrapper").classList.add("loading");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    enableScroll();
    this.removeAttribute('open');
    this.classList.remove("active");
    this.querySelector(".qv-wrapper").classList.remove("loading");
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }

  hideAddToCart() {
    this.removeAttribute('open');
    this.classList.remove("active");
    this.querySelector(".qv-wrapper").classList.remove("loading");
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('quickview-dialog', QuickviewDialog);



class QuickviewOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.product-popup-modal__button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('quickview-opener', QuickviewOpener);








class LocalizationDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'LOCALIZATION-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {

    this.openedBy = opener;
    // Check if any element with the class "mobile-menu-overlay" or "mobile-menu-overlay3" has the class "active"
    var element = document.querySelector('.mobile-menu-overlay');
    var element3 = document.querySelector('.mobile-menu-overlay3');
    
    if (element && element.classList.contains('active') || (element3 && element3.classList.contains('active'))) {
      //
    } else {
      disableScroll();
    }
    const popup = this.querySelector('.template-popup');
    this.setAttribute('open', '');
    this.classList.add("active");
    this.querySelector(".qv-wrapper").classList.add("loading");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

  }

  hide() {

    var btn = $(".product-popup-modal__button.link.modalbutton.loading")
    btn.removeClass('loading');

    // Check if any element with the class "mobile-menu-overlay" or "mobile-menu-overlay3" has the class "active"
    var element = document.querySelector('.mobile-menu-overlay');
    var element3 = document.querySelector('.mobile-menu-overlay3');
    
    if (element && element.classList.contains('active') || (element3 && element3.classList.contains('active'))) {
      //
    } else {
      enableScroll();
    }

    this.removeAttribute('open');
    this.classList.remove("active");
    this.querySelector(".qv-wrapper").classList.remove("loading");
    this.openedBy.setAttribute("aria-expanded","false");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('localization-dialog', LocalizationDialog);



class LocalizationOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('.product-popup-modal__button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('localization-opener', LocalizationOpener);








class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
     window.pauseAllMedia();
     if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
    
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dragging = false;
    this.dragStartX = 0;
    this.scrollLeftStart = 0;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.slider.addEventListener('mousedown', this.onDragStart.bind(this));
    window.addEventListener('mousemove', this.onDragThrottled.bind(this));
    window.addEventListener('mouseup', this.onDragEnd.bind(this));
    this.slider.addEventListener('click', this.onSliderClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.dragging) return; // Disable button click when dragging
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onDragStart(event) {
    event.preventDefault();
    this.dragging = true;
    this.dragStartX = event.clientX;
    this.scrollLeftStart = this.slider.scrollLeft;
  }

  onDrag(event) {
    event.preventDefault();
    if (!this.dragging) return;
    const dragDeltaX = (event.clientX - this.dragStartX) / 1; // Adjust the divisor to control the scroll speed
    this.slider.scrollLeft = this.scrollLeftStart - dragDeltaX;
    this.update();
  }

  onDragEnd(event) {
    event.preventDefault();
    this.dragging = false;
  }

  onSliderClick(event) {
    if (this.dragging) {
      event.preventDefault(); // Prevent click event when dragging
    }
  }

  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  // Throttle the onDrag method to improve performance
  onDragThrottled = this.throttle(this.onDrag, 16).bind(this);
}

customElements.define('slider-component', SliderComponent);


class VariantSelects extends HTMLElement {

 constructor() {
    super();
    this.initLoad();
    this.addEventListener('change', this.onVariantChange);
  }
  initLoad(){
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
  }

  onVariantChange() {  
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    //this.scrollBack();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.renderProductInfo();
      this.updateURL();
      this.updateVariantInput();
      this.doIshiTasks();
    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {



    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var current_media_id = this.currentVariant.featured_media.id;
    var current_variant_id = this.currentVariant.id;
    var current_variant_name = this.currentVariant.name;

    //Slide back on button click
    const sliderContainer = document.querySelector('.image-slider-inside');


  
    // Check if the slider container element was found
 //    if (sliderContainer) {
      // Reset the scroll position to 0 (start of the slider) with smooth scrolling
 //      sliderContainer.scrollTo({
  //       left: 0,
  //       behavior: 'smooth'
  //     });
  //     }  
    
    var EngravingIcons = $('.grid__item.imgBgx1[value="'+current_variant_id+'"]');
    
    // Check if EngravingIcons has any elements
    if (EngravingIcons.length > 0) {
        // Hide all elements with the class '.grid__item.imgBgx1'
        $('.grid__item.imgBgx1').hide();
    
        // Set the display property to 'inline-block' for EngravingIcons
        EngravingIcons.css('display', 'inline-block');
    }
    
    var imagePositions = $('.Variant-Positions option[value="'+current_variant_id+'"]').data("image-positions");
    
    if (typeof imagePositions !== 'string') {
        imagePositions = String(imagePositions);
    }
    
    var imagePositionsArr = imagePositions ? imagePositions.split(',').map(function(item) { return $.trim(item); }).filter(Boolean) : [];
    
    var $mainSlides = $('.images-sl1');
    var $previewThumbs = $('.preview-thumbnail');
    var galleryElement = document.querySelector('.product-image-gallery'); // Get the gallery container element
    var mainSliderElement = galleryElement ? galleryElement.querySelector('.image-slider-inside') : null;
    
    $mainSlides.hide();
    $previewThumbs.hide();
    
    if (imagePositionsArr.length > 0) {
        var allRequiredMediaFound = true;
    
        $.each(imagePositionsArr, function(index, position) {
            var $image = $('#image-position-' + position);
            var $preview = $previewThumbs.filter('[data-slide-index="' + position + '"]');
    
            if ($image.length && $preview.length) {
                $image.show();
                $preview.show();
            } else {
                allRequiredMediaFound = false;
                return false;
            }
        });
    
        if (!allRequiredMediaFound) {
            $mainSlides.show();
            $previewThumbs.show();
        }
    
    } else {
        $mainSlides.show();
        $previewThumbs.show();
    }
    
    /*
    if (mainSliderElement) {
        mainSliderElement.scrollTo({ left: 0, behavior: 'auto' });
    }
        */
    
    if (galleryElement) {
        setTimeout(() => {
           galleryElement.dispatchEvent(new CustomEvent('gallery:needsUpdate'));
        }, 10);
    }


    
    // For product page with flickity
    if (document.querySelector('.product__image-slider')) {
      var media_len = document.querySelector('.product__image-slider .flickity-slider').childElementCount;
      var media_id_array = [];
      for (let i = 0; i < media_len; i++) {
        media_id_array.push(parseInt(document.querySelector('.product__image-slider').querySelectorAll("img")[i].getAttribute('data-media-id')));
      }
      flkty.select(media_id_array.indexOf(current_media_id));
    }
    // For featured products on homepage without flickity
    else if (document.querySelector('.product__media-list')) {
      var featured_product_media_len = document.querySelector('.product__media-list').childElementCount;
      for (let i = 0; i < featured_product_media_len; i++) {
        var child = document.querySelector('.product__media-list').children[i];
        if (child.getAttribute('data-media-id').indexOf(current_media_id) > 0) {
          child.style.display = "block";
        } else {
          child.style.display = "none";
        }
      }
    }
  }
  
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /*
  scrollBack() {
    const sliderContainer = document.querySelector('.image-slider-inside');
    
    // Check if the slider container element was found
    if (sliderContainer) {
      // Reset the scroll position to 0 (start of the slider) with smooth scrolling
      sliderContainer.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
     }  
  }
     */
  
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

renderProductInfo() {

var button = this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);


var variantId = this.currentVariant.id;
var variantName = this.currentVariant.title;
var scriptTags = document.querySelectorAll('script[type="application/json"]');
var title = this.dataset.title;

  
// Function to parse JSON data and return product data by variant ID
function getProductData(scriptTag, variantId) {
    var jsonData = JSON.parse(scriptTag.textContent.trim());
    for (var i = 0; i < jsonData.length; i++) {
        if (jsonData[i].idmain === variantId) {
            return {
                title: jsonData[i].title,
                original_price: jsonData[i].original_price,
                discounted_price: jsonData[i].discounted_price,
                price: jsonData[i].price            
            };
        }
    }
    return null;
}
  
// Loop through all script tags with JSON data
scriptTags.forEach(function(scriptTag) {
    var product = getProductData(scriptTag, variantId, variantName);
    if (product) {

      console.log(variantName)


        // Get all price elements and discount elements based on the title class
        var priceElements = document.querySelectorAll(".price.main." + title + ", .price-item--sale.main." + title);
        var saleAmount = document.querySelectorAll(".salemain." + title + " > span");
        var priceElementsWithDiscount = document.querySelectorAll(".discount-bar.main." + title);
        var variantNameChange = document.querySelectorAll(".form__label > span");
        
        variantNameChange.forEach(function(el) {
          el.innerHTML = variantName; // or el.textContent = variantName;
        });
      
        // Function to calculate the discounted price
        function calculateDiscountedPrice(originalPrice, discountPercentage) {
            return originalPrice * (1 - discountPercentage / 100);
        }
        
        // Update price elements with the original price
        priceElements.forEach(function(element) {
            element.innerHTML = product.price;
        });

        // Update sale amount
        saleAmount.forEach(function(element) {
            element.innerHTML = product.discounted_price;
        });
        
          // Function to clean price string and convert to float
          function parsePrice(priceString) {
              return parseFloat(priceString.replace(/[^\d.-]/g, ''));
          }

      
        var colorvariants = document.querySelector(".color-variants.main." + title);
      
        if (colorvariants) {
            colorvariants.innerHTML = product.title
        }
      
        var regularPriceElement = document.querySelector(".price-item--regular.main." + title);
        
        if (regularPriceElement) {
            regularPriceElement.innerHTML = (product.original_price || '').trim();
        }
    }
});


}


  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButton.textContent = text;
      addButton.id = 'addtocartbutton-soldout';
    } else {
    if (addButton.getAttribute('data-fill') === 'no' || addButton.getAttribute('stock') === 'no') {
      addButton.textContent = window.variantStrings.addToCart;
      addButton.id = 'addtocartbutton';
      } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      addButton.id = 'addtocartbutton';
      }
    }
    
    if (!modifyClass) return;


  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  doIshiTasks() {
	var variant = this.currentVariant;
    var skuTarget = document.querySelector(".variant-sku");
	if (typeof(skuTarget) != 'undefined' && skuTarget != null) {
		document.querySelector(".variant-sku").innerHTML = variant.sku;
	}
    if (document.getElementsByClassName("ishi-progress-content").length) {
	  var stock = 0;
      var variantSpan =  document.getElementById("variant-" + variant.id);
      if (typeof(variantSpan) != 'undefined' && variantSpan != null)
      {
      	stock = parseInt(variantSpan.getAttribute("data-stock"));
      }
      var maxqty = parseInt(document.getElementsByClassName("ishi-progress-content")[0].getAttribute("data-quantity"));
	  document.getElementById("variant-stock").innerHTML = stock;
      if(stock > 0 && stock <= maxqty) {
        document.getElementsByClassName("ishi-progress-content")[0].classList.remove("hidden");
		var progressSpan =  document.getElementById("ishi-progress-bar").getElementsByTagName("span")[0];
		switch(stock){case 9:progressSpan.style.width = "65%";break;case 8:progressSpan.style.width = "60%";break;case 7:progressSpan.style.width = "55%";break;case 6:progressSpan.style.width = "50%";break;case 5:progressSpan.style.width = "45%";break;case 4:progressSpan.style.width = "30%";break;case 3:progressSpan.style.width = "20%";break;case 2:progressSpan.style.width = "10%";break;case 1:progressSpan.style.width = "5%";break;default:progressSpan.style.width = "90%";}
     } else {
         document.getElementsByClassName("ishi-progress-content")[0].classList.add("hidden");
      }
	} 

  }
}

customElements.define('variant-selects', VariantSelects);













class VariantSelectsGrid extends HTMLElement {
  
 constructor() {
    super();
    this.initLoad();
    this.addEventListener('change', this.onVariantChange);
  }
  initLoad(){
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();


      this.renderProductInfo();
      this.doIshiTasks();
    
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantStatuses() {

    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

renderProductInfo() {


 var title = this.dataset.title;

var currentColor = this.options[0];
var colorvariants = document.querySelector(".color-variants.collection." + title);

if (colorvariants) {
  colorvariants.innerHTML = currentColor; // Set innerHTML to the current color
}
  
var variantId = this.currentVariant.id;
  
var scriptTags = document.querySelectorAll('script[type="application/json"]');
  
// Function to parse JSON data and return product data by variant ID
function getProductData(scriptTag, variantId) {
    var jsonData = JSON.parse(scriptTag.textContent.trim());
    for (var i = 0; i < jsonData.length; i++) {
        if (jsonData[i].id2 === variantId) {
            return {
                title: jsonData[i].title,
                original_price: jsonData[i].original_price,
                price: jsonData[i].price
            };
        }
    }
    return null;
}
  
// Loop through all script tags with JSON data
scriptTags.forEach(function(scriptTag) {
    var product = getProductData(scriptTag, variantId);
    if (product) {

        var priceElements = document.querySelectorAll(".price.collection." + title + ", .price-item--sale.collection." + title);

        // Check if original price exists, if yes, set product-flags class display to block
        if (product.original_price.trim() !== "") {
            var saleprice = document.querySelectorAll(".product-flags." + title);
            
            // Iterate through each selected element and set display to block
            saleprice.forEach(function(element) {
                element.style.display = "block";
            });
            // Set display block of class outstock-overlay to none
        } else {
            var saleprice = document.querySelectorAll(".product-flags." + title);
            
            // Iterate through each selected element and set display to block
            saleprice.forEach(function(element) {
                element.style.display = "none";
            });
        }

      
        priceElements.forEach(function(element) {
            element.innerHTML = product.price;
        });

        var colorvariants = document.querySelector(".color-variants.collection." + title);
      console.log(colorvariants)
      
        if (colorvariants) {
            colorvariants.innerHTML = product.title
        }
      
        var regularPriceElement = document.querySelector(".price-item--regular.collection." + title);

        if (regularPriceElement) {
            regularPriceElement.innerHTML = (product.original_price || '').trim();
        }
    }
});



  
}


  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButton.textContent = text;
      addButton.id = 'addtocartbutton-soldout';
    } else {
    if (addButton.getAttribute('data-fill') === 'no' || addButton.getAttribute('stock') === 'no') {
      addButton.textContent = window.variantStrings.addToCart;
      addButton.id = 'addtocartbutton';
      } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      addButton.id = 'addtocartbutton';
      }
    }
    
    if (!modifyClass) return;


  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  doIshiTasks() {
	var variant = this.currentVariant;
    var skuTarget = document.querySelector(".variant-sku");
	if (typeof(skuTarget) != 'undefined' && skuTarget != null) {
		document.querySelector(".variant-sku").innerHTML = variant.sku;
	}
    if (document.getElementsByClassName("ishi-progress-content").length) {
	  var stock = 0;
      var variantSpan =  document.getElementById("variant-" + variant.id);
      if (typeof(variantSpan) != 'undefined' && variantSpan != null)
      {
      	stock = parseInt(variantSpan.getAttribute("data-stock"));
      }
      var maxqty = parseInt(document.getElementsByClassName("ishi-progress-content")[0].getAttribute("data-quantity"));
	  document.getElementById("variant-stock").innerHTML = stock;
      if(stock > 0 && stock <= maxqty) {
        document.getElementsByClassName("ishi-progress-content")[0].classList.remove("hidden");
		var progressSpan =  document.getElementById("ishi-progress-bar").getElementsByTagName("span")[0];
		switch(stock){case 9:progressSpan.style.width = "65%";break;case 8:progressSpan.style.width = "60%";break;case 7:progressSpan.style.width = "55%";break;case 6:progressSpan.style.width = "50%";break;case 5:progressSpan.style.width = "45%";break;case 4:progressSpan.style.width = "30%";break;case 3:progressSpan.style.width = "20%";break;case 2:progressSpan.style.width = "10%";break;case 1:progressSpan.style.width = "5%";break;default:progressSpan.style.width = "90%";}
     } else {
         document.getElementsByClassName("ishi-progress-content")[0].classList.add("hidden");
      }
	} 

  }
}








customElements.define('variant-selects-grid', VariantSelectsGrid);



class VariantRadiosGrid extends VariantSelectsGrid {

  constructor() {
    super();
  }


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
    const inputs = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios-grid', VariantRadiosGrid);






























class VariantSelectsGridUpsellDesktop extends HTMLElement {
 constructor() {
    super();
    this.initLoad();
    this.addEventListener('change', this.onVariantChange);
  }
  initLoad(){
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.renderProductInfo();
    }
    
  }

  

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

renderProductInfo() {

var status = this.currentVariant.available;

var cartButton = document.querySelector('.cart-button.upselldesktop.' + this.dataset.title);
cartButton.setAttribute('atc-id', this.currentVariant.id);
  
const addToCartElementAvailable = cartButton.parentElement.querySelector('.add-to-cart.available');
const addToCartElementSoldout = cartButton.parentElement.querySelector('.add-to-cart.sold-out');

if (cartButton) {
    if (status === true) {
        cartButton.removeAttribute('disabled');
        cartButton.classList.remove('sold-out');
        addToCartElementAvailable.style.display = 'block';
        addToCartElementSoldout.style.display = 'none';
    } else {
        cartButton.setAttribute('disabled', 'disabled');
        cartButton.classList.add('sold-out');
        addToCartElementAvailable.style.display = 'none';
        addToCartElementSoldout.style.display = 'block';
    }
}



  var variantId = this.currentVariant.id;
    
  var scriptTags = document.querySelectorAll('script[type="application/json"]');
  var title = this.dataset.title;
    
  // Function to parse JSON data and return product data by variant ID
  function getProductData(scriptTag, variantId) {
      var jsonData = JSON.parse(scriptTag.textContent.trim());
      for (var i = 0; i < jsonData.length; i++) {
          if (jsonData[i].id2 === variantId) {
              return {
                  title: jsonData[i].title,
                  original_price: jsonData[i].original_price,
                  price: jsonData[i].price
              };
          }
      }
      return null;
  }
    
  // Loop through all script tags with JSON data
  scriptTags.forEach(function(scriptTag) {
      var product = getProductData(scriptTag, variantId);
      if (product) {
      

          var priceElements = document.querySelectorAll(".price.upselldesktop." + title + ", .price-item--sale.upselldesktop." + title);
  
        
          priceElements.forEach(function(element) {
              element.innerHTML = product.price;
          });
  
          var colorvariants = document.querySelector(".color-variants.upselldesktop." + title);
        
          if (colorvariants) {
              colorvariants.innerHTML = product.title
          }
        
          var regularPriceElement = document.querySelector(".price-item--regular.upselldesktop." + title);
  
          if (regularPriceElement) {
              regularPriceElement.innerHTML = (product.original_price || '').trim();
          }
      }
  });
}



  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}








customElements.define('variant-selects-grid-upselldesktop', VariantSelectsGridUpsellDesktop);



class VariantRadiosGridUpsellDesktop extends VariantSelectsGridUpsellDesktop {

  constructor() {
    super();
  }


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
    const inputs = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios-grid-upselldesktop', VariantRadiosGridUpsellDesktop);
















class VariantSelectsGridUpsellMobile extends HTMLElement {
 constructor() {
    super();
    this.initLoad();
    this.addEventListener('change', this.onVariantChange);
  }
  initLoad(){
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.renderProductInfo();
    }
    
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

renderProductInfo() {

  
var status = this.currentVariant.available;

var cartButton = document.querySelector('.cart-button.upsellmobile.' + this.dataset.title);
cartButton.setAttribute('atc-id', this.currentVariant.id);
  
const addToCartElementAvailable = cartButton.parentElement.querySelector('.add-to-cart.available');
const addToCartElementSoldout = cartButton.parentElement.querySelector('.add-to-cart.sold-out');

if (cartButton) {
    if (status === true) {
        cartButton.removeAttribute('disabled');
        cartButton.classList.remove('sold-out');
        addToCartElementAvailable.style.display = 'block';
        addToCartElementSoldout.style.display = 'none';
    } else {
        cartButton.setAttribute('disabled', 'disabled');
        cartButton.classList.add('sold-out');
        addToCartElementAvailable.style.display = 'none';
        addToCartElementSoldout.style.display = 'block';
    }
}




var variantId = this.currentVariant.id;
  
var scriptTags = document.querySelectorAll('script[type="application/json"]');
var title = this.dataset.title;
  
// Function to parse JSON data and return product data by variant ID
function getProductData(scriptTag, variantId) {
    var jsonData = JSON.parse(scriptTag.textContent.trim());
    for (var i = 0; i < jsonData.length; i++) {
        if (jsonData[i].id2 === variantId) {
            return {
                title: jsonData[i].title,
                original_price: jsonData[i].original_price,
                price: jsonData[i].price
            };
        }
    }
    return null;
}
  
// Loop through all script tags with JSON data
scriptTags.forEach(function(scriptTag) {
    var product = getProductData(scriptTag, variantId);
    if (product) {
      

        var priceElements = document.querySelectorAll(".price.upsellmobile." + title + ", .price-item--sale.upsellmobile." + title);

      
        priceElements.forEach(function(element) {
            element.innerHTML = product.price;
        });

        var colorvariants = document.querySelector(".color-variants.upsellmobile." + title);
      
        if (colorvariants) {
            colorvariants.innerHTML = product.title
        }
      
        var regularPriceElement = document.querySelector(".price-item--regular.upsellmobile." + title);

        if (regularPriceElement) {
            regularPriceElement.innerHTML = (product.original_price || '').trim();
        }
    }
});



  
}



  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}








customElements.define('variant-selects-grid-upsellmobile', VariantSelectsGridUpsellMobile);



class VariantRadiosGridUpsellMobile extends VariantSelectsGridUpsellMobile {

  constructor() {
    super();
  }


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
    const inputs = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios-grid-upsellmobile', VariantRadiosGridUpsellMobile);

















/* Normal */

class VariantRadios extends VariantSelects {

  constructor() {
    super();
  }


  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
    const inputs = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;;
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


function setTheCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
    
function getTheCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
    
function eraseTheCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


function setupWishlistButtons() {
    if (getTheCookie("wishlist") != null && getTheCookie("wishlist") != '' && getTheCookie("wishlist") != '') {
        var str = String(getTheCookie("wishlist")).split("__");
        var cleanedstr = str.filter(e => e.length);
        for (var i = 0; i < cleanedstr.length; i++) {

            for (j = 0; j < document.querySelectorAll('.added-wishbutton-' + cleanedstr[i]).length; ++j) {
                document.querySelectorAll('.added-wishbutton-' + cleanedstr[i])[j].style.display = "block";
            }

            for (j = 0; j < document.querySelectorAll('.default-wishbutton-' + cleanedstr[i]).length; ++j) {
                document.querySelectorAll('.default-wishbutton-' + cleanedstr[i])[j].style.display = "none";
            }

            for (j = 0; j < document.querySelectorAll('.loadding-wishbutton-' + cleanedstr[i]).length; ++j) {
                document.querySelectorAll('.loadding-wishbutton-' + cleanedstr[i])[j].remove();
            }

        }
    }
}


function setGridLayout() {
  if(!document.querySelectorAll("#ProductGridContainer").length)return;
  var gridCookie = getTheCookie('collectiongrid-layout');
  if(document.querySelectorAll("[data-id='" + gridCookie + "']").length) {
    document.querySelectorAll(".collectiongrid-layout").forEach((element) => {
    	element.classList.remove("active");
    });
  } else {
    gridCookie = document.querySelector(".collectiongrid-layout.grid-layout-default").getAttribute("data-id");
    setTheCookie("collectiongrid-layout", gridCookie, 14);
  }  
  var classNames = document.querySelector("[data-id='" + gridCookie + "']").classList;
  document.querySelector("[data-id=" + gridCookie + "]").classList =  classNames + " active";
  document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
    element.className = document.querySelector("[data-id=" + gridCookie + "]").getAttribute("data-class");
  });

  //list-view has the buttons and grid-view has been selected
  if((gridCookie == "collectiongrid-layout-2" || gridCookie == "collectiongrid-layout-3" || gridCookie == "collectiongrid-layout-4") && document.getElementById("product-grid").querySelectorAll('li .card-information__wrapper .thumbnail-buttons').length) {
    document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card__inner").append(node);
  	});
  }
  //grid-view has the buttons and listview has been selected
  if((gridCookie == "collectiongrid-layout-1") && document.getElementById("product-grid").querySelectorAll('li .card__inner .thumbnail-buttons').length) {
  	document.getElementById("product-grid").querySelectorAll('li').forEach((element) => {
      var node = element.querySelector(".thumbnail-buttons");
      node.parentElement.removeChild(node);
      element.querySelector(".card-information__wrapper").append(node);
  	});
  }
	

  document.querySelector('#shopify-section-Ishi_sidebar')? gridCookie += " with-sidebar" : '';
  document.getElementById("ProductGridContainer").className = gridCookie;
}



function removeFromCartJS(variantID) {

    var xhr = new XMLHttpRequest();
    var currentURL = window.location.href; // Get the current URL
  
    // Check if the current URL contains "/sl"

      var url = window.Shopify.routes.root + "cart/change.js"; // Use the default URL

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {

        if (document.querySelector('.engravings')) {
          makeRequest();
          handleResponse();
        }
          var parsedState = JSON.parse(xhr.responseText);

       //window.scrollTo({top: 0, behavior: 'smooth'});
       document.querySelector('cart-notification').renderContentsedit(parsedState);
       // Find elements with class "alert-nosuccess" and set display: none
        var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess');
        alertNosuccessElements.forEach(function (element) {
          element.style.display = 'none';
        });
        // Select the cart-footer element
        const cartFooter = document.querySelector('.cart-footer');
        const cartFooter2 = document.querySelector('.cart-footer2');

        const progressWrapper = document.querySelector("#cart-notification-goal");
        // Add the "is-loading" class
        cartFooter.classList.add('is-loading');
        cartFooter2.classList.add('is-loading');
        progressWrapper.classList.add('is-loading');
        
        const inputElement = document.querySelector('.quantity__input2');
        if (inputElement) {
            inputElement.disabled = true;
        }
        
        // After 1.3 seconds, remove the "is-loading" class
        setTimeout(() => {
          cartFooter.classList.remove('is-loading');
          cartFooter2.classList.remove('is-loading');
          progressWrapper.classList.remove('is-loading');
          inputElement.disabled = false;
        }, 1000); // 1.3 seconds in milliseconds (1000 milliseconds = 1 second)

      $('.holder').removeClass("active");
      $('.closecart').removeClass("active");
      $('[id="cart-notification-default"]').removeClass("active");
      $('.featurescontent2').removeClass("active");
      $('.goal').removeClass("active");
      $('.item-upsell-desktop').removeClass("active");
      $('.progress-wrapper').removeClass("active");
      $('.shippingdetails').removeClass("active");
      $('#cart-notification-checkout').removeClass("active");
      $('.cart-notification__header').removeClass("active");
      $('.cart-footer').removeClass("active");
      $('.cart-footer2').removeClass("active");
      $('.alert-nosuccess').removeClass("active");
      $('.alert-success').removeClass("active");

      
        
      }
    };
    var sectionsToRender = ["cart-notification-productedit", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": 0, "line": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
    xhr.send(data);
}

function DecreaseMyCart(variantID,quantity) {
    var xhr = new XMLHttpRequest();
    var currentURL = window.location.href; // Get the current URL
  
    // Check if the current URL contains "/sl"
      var url = window.Shopify.routes.root + "cart/change.js"; // Use the default URL

    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        if (document.querySelector('.engravings')) {
          makeRequest();
          handleResponse();
        }
          var parsedState = JSON.parse(xhr.responseText);
          //window.scrollTo({top: 0, behavior: 'smooth'});
          document.querySelector('cart-notification').renderContentsedit(parsedState);
       // Find elements with class "alert-nosuccess" and set display: none
        var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess');
        alertNosuccessElements.forEach(function (element) {
          element.style.display = 'none';
        });
        // Select the cart-footer element
        const cartFooter = document.querySelector('.cart-footer');
        const cartFooter2 = document.querySelector('.cart-footer2');

        const progressWrapper = document.querySelector("#cart-notification-goal");
        // Add the "is-loading" class
        cartFooter.classList.add('is-loading');
        cartFooter2.classList.add('is-loading');
        progressWrapper.classList.add('is-loading');
                
        const inputElement = document.querySelector('.quantity__input2');
        if (inputElement) {
            inputElement.disabled = true;
        }
        
        // After 1.3 seconds, remove the "is-loading" class
        setTimeout(() => {
          cartFooter.classList.remove('is-loading');
          cartFooter2.classList.remove('is-loading');
          progressWrapper.classList.remove('is-loading');
          inputElement.disabled = false;
        }, 1000); // 1.3 seconds in milliseconds (1000 milliseconds = 1 second)

      $('.holder').removeClass("active");
      $('.closecart').removeClass("active");
      $('[id="cart-notification-default"]').removeClass("active");
      $('.featurescontent2').removeClass("active");
      $('.goal').removeClass("active");
      $('.item-upsell-desktop').removeClass("active");
      $('.progress-wrapper').removeClass("active");
      $('.shippingdetails').removeClass("active");
      $('#cart-notification-checkout').removeClass("active");
      $('.cart-notification__header').removeClass("active");
      $('.cart-footer').removeClass("active");
      $('.cart-footer2').removeClass("active");
      $('.alert-nosuccess').removeClass("active");
      $('.alert-success').removeClass("active");
        
      }
    };
    var sectionsToRender = ["cart-notification-productedit", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
    var sections_url = window.location.pathname;
    var data = JSON.stringify({"quantity": quantity, "line": variantID, "sections" : sectionsToRender, "sections_url" :sections_url });
    xhr.send(data);
}


var _0x5e7b=['\x6c\x6f\x61\x64','\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68','\x2e\x73\x68\x6f\x70\x69\x66\x79\x2d\x70\x63\x5f\x5f\x62\x61\x6e\x6e\x65\x72\x5f\x5f\x62\x74\x6e\x2d\x61\x63\x63\x65\x70\x74','\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63\x74\x6f\x72','\x63\x6c\x69\x63\x6b','\x73\x65\x74\x54\x69\x6d\x65\x6f\x75\x74','\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'];window[_0x5e7b[6]](_0x5e7b[0],()=>{window[_0x5e7b[5]](()=>{if(window[_0x5e7b[1]]<=768){document[_0x5e7b[3]](_0x5e7b[2])[_0x5e7b[4]]()}},2000)})
const engravingsDiv = document.getElementsByClassName('engravings')[0];
const buttonEngrave = document.getElementById('buttonengrave');



function handleResponse() {
 if (document.querySelector('.engravings')) {
  try {
    const data = JSON.parse(this.responseText);

    // Check if data has the "engravings" property
    if (!data || !data.engravings) {
      return;
    }

    engravingsDiv.innerHTML = data.engravings;
  } catch (error) {
  }
 }        
}

function makeRequest() {
  if (document.querySelector('.engravings')) {
    // Clear the innerHTML before making a new request
    engravingsDiv.innerHTML = '';
    
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
    request.open('GET', '/?sections=engravings', true);
    request.send();
  }  
}




function IncreaseMyCart(variantID, newQuantity) {
  var xhr = new XMLHttpRequest();
  var currentURL = window.location.href; // Get the current URL

  // Check if the current URL contains "/sl"

  var url = window.Shopify.routes.root + "cart/change.js"; // Use the default URL

  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
      if (document.querySelector('.engravings')) {
          makeRequest();
          handleResponse();
      }
        
        var parsedState = JSON.parse(xhr.responseText);
        // Render other contents or perform additional actions as needed
        document.querySelector('cart-notification').renderContentsedit(parsedState);

       // Find elements with class "alert-nosuccess" and set display: none
        var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess');
        alertNosuccessElements.forEach(function (element) {
          element.style.display = 'none';
        });
        
      $('.holder').removeClass("active");
      $('.closecart').removeClass("active");
      $('[id="cart-notification-default"]').removeClass("active");
      $('.featurescontent2').removeClass("active");
      $('.goal').removeClass("active");
      $('.item-upsell-desktop').removeClass("active");
      $('.progress-wrapper').removeClass("active");
      $('.shippingdetails').removeClass("active");
      $('#cart-notification-checkout').removeClass("active");
      $('.cart-notification__header').removeClass("active");
      $('.cart-footer').removeClass("active");
      $('.cart-footer2').removeClass("active");
      $('.alert-nosuccess').removeClass("active");
      $('.alert-success').removeClass("active");

        // Select the cart-footer element
        const cartFooter = document.querySelector('.cart-footer');
        const cartFooter2 = document.querySelector('.cart-footer2');
        
        const progressWrapper = document.querySelector("#cart-notification-goal");
        // Add the "is-loading" class
        cartFooter.classList.add('is-loading');
        cartFooter2.classList.add('is-loading');
        progressWrapper.classList.add('is-loading');
        
        const inputElement = document.querySelector('.quantity__input2');
        if (inputElement) {
            inputElement.disabled = true;
        }
        
        // After 1.3 seconds, remove the "is-loading" class
        setTimeout(() => {
          cartFooter.classList.remove('is-loading');
          cartFooter2.classList.remove('is-loading');
          progressWrapper.classList.remove('is-loading');
          inputElement.disabled = false;
        }, 1000); // 1.3 seconds in milliseconds (1000 milliseconds = 1 second)
  
        
      } else {
      console.error("Error status:", xhr.status);
      console.error("Error response:", xhr.responseText);
      $('.alert-nosuccess').addClass("active");
        
      // Find elements with class "alert-nosuccess" and set display: block
      var alertNosuccessElements = document.querySelector('.alert-nosuccess');
      if (alertNosuccessElements) {
        alertNosuccessElements.style.display = 'block';
      }
        
      // Find elements with class "alert-success" and set display: none
      var alertSuccessElements = document.querySelectorAll('.alert-success');
      alertSuccessElements.forEach(function (element) {
        element.style.display = 'none';
      });
        
        function findProductsWithVariantID() {
          var elements = document.querySelectorAll('[productkey="' + variantID + '"]');
 
          elements.forEach(function (element) {
            element.value = --newQuantity; // Set the value for each individual element
          });
          
          var QTYreduce = 0;
      
          elements.forEach(function (element) {
            var value = element.getAttribute("value");
            if (value) {
              QTYreduce += parseInt(value);
            }
          });
      
          return QTYreduce;
        }
      

        
      }
    }
  };
  
  var sectionsToRender = ["cart-notification-productedit", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({
    "quantity": newQuantity,
    "line": variantID,
    "sections": sectionsToRender,
    "sections_url": sections_url
  });



  
  xhr.send(data);
}




$('.mobile-menu-overlay3').on('click', function() {
          enableScroll();
        $(".toggle-dropdown1").removeClass("active");
        $('.holder').removeClass("active");
        $('.mobile-menu-overlay3').removeClass("active");
        $('.closecart').removeClass("active");
        $('[id="cart-notification-default"]').removeClass("active");
        $('.featurescontent2').removeClass("active");
        $('.goal').removeClass("active");
        $('.item-upsell-desktop').removeClass("active");
        $('.progress-wrapper').removeClass("active");
        $('.shippingdetails').removeClass("active");
        $('#cart-notification-checkout').removeClass("active");
        $('.cart-notification__header').removeClass("active");
        $('.cart-footer').removeClass("active");
        $('.cart-footer2').removeClass("active");
        $('.alert-nosuccess').removeClass("active");
        $('.alert-success').removeClass("active");
        $('[data-href="#cart-notification"]').attr("aria-expanded","false");
  
});



var isScrollDisabled = false; // Global variable to track scroll state


function disableScroll() {
    if (!isScrollDisabled) { // Check if scrolling is not already disabled
        var htmlEl = document.querySelector('html');
        var body = document.body;
        var bodyScrollTop = body.scrollTop;
        var htmlScrollTop = htmlEl.scrollTop;
        var scrollTop = bodyScrollTop ? bodyScrollTop : htmlScrollTop;
        this.currentPosition = htmlEl.style.position;
        this.currentOverflow = htmlEl.style.overflowY;
        this.currentWidth = htmlEl.style.width;
        htmlEl.style.position = 'fixed';
        htmlEl.style.overflowY = 'scroll';
        htmlEl.style.width = '100%';
        htmlEl.style.top = 0 - scrollTop + 'px';

        function check_iOS() {
            return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
                // iPad on iOS 13 detection
                || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
        }

        if (check_iOS()) {
            htmlEl.style.setProperty('--scrollTop', Math.abs(scrollTop) + 'px');
        }

        isScrollDisabled = true; // Set scroll state to disabled
        isScrollEnabled = false; // Set scroll state to disabled
    }
}


function enableScroll() {
      var htmlEl = document.querySelector('html');
      var body = document.body;

      setTimeout(function() {
          htmlEl.style.position = '';
          htmlEl.style.overflowY = '';
          htmlEl.style.width = '';
      
          var scrollTop = -parseInt(htmlEl.style.top);
          htmlEl.scrollTop = scrollTop;
          body.scrollTop = scrollTop;
      }, 300);
        isScrollDisabled = false; // Set scroll state to disabled
}
  




function addToCartJS(qty, variantID, btn) { 

  var xhr = new XMLHttpRequest();
  var currentURL = window.location.href; // Get the current URL

  // Check if the current URL contains "/sl"

 var url = window.Shopify.routes.root + "cart/add.js"; // Use the default URL

  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {


        document.querySelector(".qv-wrapper").classList.add("loading");
        const quickviewDialog = document.querySelector('quickview-dialog');
        
        // Call the hideAddToCart() method on the instance
        quickviewDialog.hideAddToCart();
        
        var parsedState = JSON.parse(xhr.responseText);
        document.querySelector('cart-notification').renderContents(parsedState);
        btn.classList.remove("loading");
        document.querySelector(".qv-wrapper").classList.remove("loading");
       // Find elements with class "alert-nosuccess" and set display: none
        var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess');
        alertNosuccessElements.forEach(function (element) {
          element.style.display = 'none';
        });



        
    $('.holder').addClass("active");
    $('.closecart').addClass("active");
    $('[id="cart-notification-default"]').addClass("active");
    $('.featurescontent2').addClass("active");
    $('.goal').addClass("active");
    $('.item-upsell-desktop').addClass("active"); 
    $('.progress-wrapper').addClass("active");
    $('.shippingdetails').addClass("active");
    $('#cart-notification-checkout').addClass("active");
    $('.cart-notification__header').addClass("active");
    $('.cart-footer').addClass("active");
    $('.cart-footer2').addClass("active");
    $('.alert-nosuccess').addClass("active");
    $('.alert-success').addClass("active");

        
      } else {

      $('.alert-nosuccess').removeClass("active");
      btn.classList.remove("loading");

      // Find elements with class "alert-nosuccess" and set display: block
      var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess1');
      alertNosuccessElements.forEach(function (element) {
        element.style.display = 'block';
      });
        
        function findProductsWithVariantID() {
          var elements = document.querySelectorAll('[productid="' + variantID + '"]');
          var QTYreduce = 0;
      
          elements.forEach(function (element) {
            var value = element.getAttribute("value");
            if (value) {
              QTYreduce += parseInt(value);
            }
          });
      
          return QTYreduce;
        }
      
        var QTYreduce = findProductsWithVariantID();
        
        var errorXhr = new XMLHttpRequest();
        var currentURL = window.location.href; // Get the current URL
      
        // Check if the current URL contains "/sl"
        var errorUrl = window.Shopify.routes.root + "cart/add.js"; // Use the default URL
        
        errorXhr.open("POST", errorUrl, true);
        errorXhr.setRequestHeader("Content-Type", "application/json");

        var sectionsToRender = ["cart-notification-productedit", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
        var sections_url = window.location.pathname;
        var errorData = JSON.stringify({"quantity": QTYreduce, "id": variantID, "sections": sectionsToRender, "sections_url": sections_url });

        errorXhr.send(errorData);
      }
    }
  };

  var sectionsToRender = ["cart-notification-product", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": qty, "id": variantID, "sections": sectionsToRender, "sections_url": sections_url });
  xhr.send(data);
}







function addToCartJSUpsell(qty, variantID, btn) { 

  var xhr = new XMLHttpRequest();
  var currentURL = window.location.href; // Get the current URL

  var url = window.Shopify.routes.root + "cart/add.js"; // Use the default URL

  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {

        if (document.querySelector('.engravings')) {
          makeRequest();
          handleResponse();
        }


      setTimeout(() => {
        var parsedState = JSON.parse(xhr.responseText);
        document.querySelector('cart-notification').renderContents(parsedState);
      }, 1400); //


        

        btn.classList.remove('clicked');
        btn.classList.add('finished');
        btn.querySelector('.check').style.strokeDashoffset = '0';


        // Select the cart-footer element
        const cartFooter = document.querySelector('.cart-footer');
        const cartFooter2 = document.querySelector('.cart-footer2');

        const progressWrapper = document.querySelector("#cart-notification-goal");
        // Add the "is-loading" class
        cartFooter.classList.add('is-loading');
        cartFooter2.classList.add('is-loading');
        progressWrapper.classList.add('is-loading');
        
        const inputElement = document.querySelector('.quantity__input2');
        if (inputElement) {
            inputElement.disabled = true;
        }
        
        // After 1.3 seconds, remove the "is-loading" class
        setTimeout(() => {
        btn.classList.remove("loading");
        document.querySelector(".qv-wrapper").classList.remove("loading");
       // Find elements with class "alert-nosuccess" and set display: none
        var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess');
        alertNosuccessElements.forEach(function (element) {
          element.style.display = 'none';
        });
          cartFooter.classList.remove('is-loading');
          cartFooter2.classList.remove('is-loading');
          progressWrapper.classList.remove('is-loading');
          inputElement.disabled = false;
        }, 1300); // 1.3 seconds in milliseconds (1000 milliseconds = 1 second)

      $('.holder').removeClass("active");
      $('.closecart').removeClass("active");
      $('[id="cart-notification-default"]').removeClass("active");
      $('.featurescontent2').removeClass("active");
      $('.goal').removeClass("active");
      $('.item-upsell-desktop').removeClass("active");
      $('.progress-wrapper').removeClass("active");
      $('.shippingdetails').removeClass("active");
      $('#cart-notification-checkout').removeClass("active");
      $('.cart-notification__header').removeClass("active");
      $('.cart-footer').removeClass("active");
      $('.cart-footer2').removeClass("active");
      $('.alert-nosuccess').removeClass("active");
      $('.alert-success').removeClass("active");
                


        
      } else {

      $('.alert-nosuccess').removeClass("active");
        
      // Find elements with class "alert-nosuccess" and set display: block
      var alertNosuccessElements = document.querySelectorAll('.alert-nosuccess1');
      alertNosuccessElements.forEach(function (element) {
        element.style.display = 'block';
      });
        
        function findProductsWithVariantID() {
          var elements = document.querySelectorAll('[productid="' + variantID + '"]');
          var QTYreduce = 0;
      
          elements.forEach(function (element) {
            var value = element.getAttribute("value");
            if (value) {
              QTYreduce += parseInt(value);
            }
          });
      
          return QTYreduce;
        }
      
        var QTYreduce = findProductsWithVariantID();
        
        var errorXhr = new XMLHttpRequest();
        var currentURL = window.location.href; // Get the current URL
      
          var errorUrl = window.Shopify.routes.root + "cart/add.js"; // Use the default URL
        
        errorXhr.open("POST", errorUrl, true);
        errorXhr.setRequestHeader("Content-Type", "application/json");

        var sectionsToRender = ["cart-notification-productedit", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
        var sections_url = window.location.pathname;
        var errorData = JSON.stringify({"quantity": QTYreduce, "id": variantID, "sections": sectionsToRender, "sections_url": sections_url });

        errorXhr.send(errorData);
      }
    }
  };

  var sectionsToRender = ["cart-notification-product", "upsell", "upsell-desktop-upsell", "cart-notification-button", "cart-icon-bubble"];
  var sections_url = window.location.pathname;
  var data = JSON.stringify({"quantity": qty, "id": variantID, "sections": sectionsToRender, "sections_url": sections_url });
  xhr.send(data);
}






















function convertToMoney(price) {
  var price = parseFloat(price / 100).toFixed(2);
  var currency = document.getElementsByTagName("html")[0].getAttribute("currency");
  return price + currency; 
}

function setCountDownTimer(date,target) {
  var t = date.split(/[- :]/);
  var d = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5]);
  var countDownDate = new Date(d);
  setInterval(function() {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // Display the result in the element with id="demo"
   // target.getElementsByClassName("countdown-days")[0].innerHTML = date;
    target.getElementsByClassName("countdown-days")[0].innerHTML = days < 10 ? "0" + days : days;
    target.getElementsByClassName("countdown-hours")[0].innerHTML = hours < 10 ? "0" + hours : hours;
    target.getElementsByClassName("countdown-minutes")[0].innerHTML = minutes < 10 ? "0" + minutes : minutes;
    target.getElementsByClassName("countdown-seconds")[0].innerHTML = seconds < 10 ? "0" + seconds : seconds;
  }, 1000);
}
